module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// (webpack)/~/node-libs-browser/~/readable-stream/writable-browser.js
// module id = 1064
// module chunks = 0